webpackJsonp([9],{

/***/ "25Yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StageCodeComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },
    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="mergeRequest in items" class="stage-event-item">\n            <div class="item-details">\n              <img class="avatar" :src="mergeRequest.author.avatarUrl">\n              <h5 class="item-title merge-merquest-title">\n                <a :href="mergeRequest.url">\n                  {{ mergeRequest.title }}\n                </a>\n              </h5>\n              <a :href="mergeRequest.url" class="issue-link">!{{ mergeRequest.iid }}</a>\n              &middot;\n              <span>\n                Opened\n                <a :href="mergeRequest.url" class="issue-date">{{ mergeRequest.createdAt }}</a>\n              </span>\n              <span>\n                by\n                <a :href="mergeRequest.author.webUrl" class="issue-author-link">{{ mergeRequest.author.name }}</a>\n              </span>\n            </div>\n            <div class="item-time">\n              <total-time :time="mergeRequest.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "3VML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StageIssueComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },
    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="issue in items" class="stage-event-item">\n            <div class="item-details">\n              <img class="avatar" :src="issue.author.avatarUrl">\n              <h5 class="item-title issue-title">\n                <a class="issue-title" :href="issue.url">\n                  {{ issue.title }}\n                </a>\n              </h5>\n              <a :href="issue.url" class="issue-link">#{{ issue.iid }}</a>\n              &middot;\n              <span>\n                Opened\n                <a :href="issue.url" class="issue-date">{{ issue.createdAt }}</a>\n              </span>\n              <span>\n                by\n                <a :href="issue.author.webUrl" class="issue-author-link">\n                  {{ issue.author.name }}\n                </a>\n              </span>\n            </div>\n            <div class="item-time">\n              <total-time :time="issue.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "6WU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.TotalTimeComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      time: Object
    },
    template: '\n      <span class="total-time">\n        <template v-if="Object.keys(time).length">\n          <template v-if="time.days">{{ time.days }} <span>{{ time.days === 1 ? \'day\' : \'days\' }}</span></template>\n          <template v-if="time.hours">{{ time.hours }} <span>hr</span></template>\n          <template v-if="time.mins && !time.days">{{ time.mins }} <span>mins</span></template>\n          <template v-if="time.seconds && Object.keys(time).length === 1 || time.seconds === 0">{{ time.seconds }} <span>s</span></template>\n        </template>\n        <template v-else>\n          --\n        </template>\n      </span>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "8Foh":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><path fill=\"#8C8C8C\" fill-rule=\"evenodd\" d=\"M9.678 6.722C9.353 5.167 8.053 4 6.5 4S3.647 5.167 3.322 6.722h-2.6c-.397 0-.722.35-.722.778 0 .428.325.778.722.778h2.6C3.647 9.833 4.947 11 6.5 11s2.853-1.167 3.178-2.722h2.6c.397 0 .722-.35.722-.778 0-.428-.325-.778-.722-.778h-2.6zM4.694 7.5c0-1.09.795-1.944 1.806-1.944 1.01 0 1.806.855 1.806 1.944 0 1.09-.795 1.944-1.806 1.944-1.01 0-1.806-.855-1.806-1.944z\"/></svg>\n"

/***/ }),

/***/ "8ode":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg__ = __webpack_require__("XUnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg__ = __webpack_require__("8Foh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg__);
/* eslint-disable no-param-reassign */




(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StageTestComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },
    data: function data() {
      return { iconBuildStatus: __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg___default.a, iconBranch: __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default.a };
    },

    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="build in items" class="stage-event-item item-build-component">\n            <div class="item-details">\n              <h5 class="item-title">\n                <span class="icon-build-status">' + __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg___default.a + '</span>\n                <a :href="build.url" class="item-build-name">{{ build.name }}</a>\n                &middot;\n                <a :href="build.url" class="pipeline-id">#{{ build.id }}</a>\n                <i class="fa fa-code-fork"></i>\n                <a :href="build.branch.url" class="branch-name monospace">{{ build.branch.name }}</a>\n                <span class="icon-branch">' + __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default.a + '</span>\n                <a :href="build.commitUrl" class="short-sha monospace">{{ build.shortSha }}</a>\n              </h5>\n              <span>\n                <a :href="build.url" class="issue-date">\n                  {{ build.date }}\n                </a>\n              </span>\n            </div>\n            <div class="item-time">\n              <total-time :time="build.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "GtaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StageReviewComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },
    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="mergeRequest in items" class="stage-event-item">\n            <div class="item-details">\n              <img class="avatar" :src="mergeRequest.author.avatarUrl">\n              <h5 class="item-title merge-merquest-title">\n                <a :href="mergeRequest.url">\n                  {{ mergeRequest.title }}\n                </a>\n              </h5>\n              <a :href="mergeRequest.url" class="issue-link">!{{ mergeRequest.iid }}</a>\n              &middot;\n              <span>\n                Opened\n                <a :href="mergeRequest.url" class="issue-date">{{ mergeRequest.createdAt }}</a>\n              </span>\n              <span>\n                by\n                <a :href="mergeRequest.author.webUrl" class="issue-author-link">{{ mergeRequest.author.name }}</a>\n              </span>\n              <template v-if="mergeRequest.state === \'closed\'">\n                <span class="merge-request-state">\n                  <i class="fa fa-ban"></i>\n                  {{ mergeRequest.state.toUpperCase() }}\n                </span>\n              </template>\n              <template v-else>\n                <span class="merge-request-branch" v-if="mergeRequest.branch">\n                  <i class= "fa fa-code-fork"></i>\n                  <a :href="mergeRequest.branch.url">{{ mergeRequest.branch.name }}</a>\n                </span>\n              </template>\n            </div>\n            <div class="item-time">\n              <total-time :time="mergeRequest.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "KxTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  template: "\n    <span v-if=\"count === 50\" class=\"events-info pull-right\">\n      <i class=\"fa fa-warning has-tooltip\"\n          aria-hidden=\"true\"\n          title=\"Limited to showing 50 events at most\"\n          data-placement=\"top\"></i>\n      Showing 50 events\n    </span>\n  "
});

/***/ }),

/***/ "PvA4":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"><path fill=\"#8F8F8F\" fill-rule=\"evenodd\" d=\"M28.777 18c-.91-4.008-4.494-7-8.777-7-4.283 0-7.868 2.992-8.777 7H4.01C2.9 18 2 18.895 2 20c0 1.112.9 2 2.01 2h7.213c.91 4.008 4.494 7 8.777 7 4.283 0 7.868-2.992 8.777-7h7.214C37.1 22 38 21.105 38 20c0-1.112-.9-2-2.01-2h-7.213zM20 25c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z\"/></svg>\n"

/***/ }),

/***/ "XUnj":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><g fill=\"#31AF64\" fill-rule=\"evenodd\"><path d=\"M12.5 7c0-3.038-2.462-5.5-5.5-5.5S1.5 3.962 1.5 7s2.462 5.5 5.5 5.5 5.5-2.462 5.5-5.5zM0 7c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7z\"/><path d=\"M6.28 7.697L5.045 6.464c-.117-.117-.305-.117-.42-.002l-.614.614c-.11.113-.11.303.007.42l1.91 1.91c.19.19.51.197.703.004l.264-.265L9.997 6.04c.108-.107.107-.293-.01-.408l-.612-.614c-.114-.113-.298-.12-.41-.01L6.28 7.7z\"/></g></svg>\n"

/***/ }),

/***/ "Xl4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_commit_svg__ = __webpack_require__("PvA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_commit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_icon_commit_svg__);
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StagePlanComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },

    data: function data() {
      return { iconCommit: __WEBPACK_IMPORTED_MODULE_1__svg_icon_commit_svg___default.a };
    },


    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="commit in items" class="stage-event-item">\n            <div class="item-details item-conmmit-component">\n              <img class="avatar" :src="commit.author.avatarUrl">\n              <h5 class="item-title commit-title">\n                <a :href="commit.commitUrl">\n                  {{ commit.title }}\n                </a>\n              </h5>\n              <span>\n                First\n                <span class="commit-icon">' + __WEBPACK_IMPORTED_MODULE_1__svg_icon_commit_svg___default.a + '</span>\n                <a :href="commit.commitUrl" class="commit-hash-link monospace">{{ commit.shortSha }}</a>\n                pushed by\n                <a :href="commit.author.webUrl" class="commit-author-link">\n                  {{ commit.author.name }}\n                </a>\n              </span>\n            </div>\n            <div class="item-time">\n              <total-time :time="commit.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "ZuDc":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-param-reassign */

__webpack_require__("A+3H");
var DEFAULT_EVENT_OBJECTS = __webpack_require__("sM1W");

(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  var EMPTY_STAGE_TEXTS = {
    issue: 'The issue stage shows the time it takes from creating an issue to assigning the issue to a milestone, or add the issue to a list on your Issue Board. Begin creating issues to see data for this stage.',
    plan: 'The planning stage shows the time from the previous step to pushing your first commit. This time will be added automatically once you push your first commit.',
    code: 'The coding stage shows the time from the first commit to creating the merge request. The data will automatically be added here once you create your first merge request.',
    test: 'The testing stage shows the time GitLab CI takes to run every pipeline for the related merge request. The data will automatically be added after your first pipeline finishes running.',
    review: 'The review stage shows the time from creating the merge request to merging it. The data will automatically be added after you merge your first merge request.',
    staging: 'The staging stage shows the time between merging the MR and deploying code to the production environment. The data will be automatically added once you deploy to production for the first time.',
    production: 'The production stage shows the total time it takes between creating an issue and deploying the code to production. The data will be automatically added once you have completed the full idea to production cycle.'
  };

  global.cycleAnalytics.CycleAnalyticsStore = {
    state: {
      summary: '',
      stats: '',
      analytics: '',
      events: [],
      stages: []
    },
    setCycleAnalyticsData: function setCycleAnalyticsData(data) {
      this.state = Object.assign(this.state, this.decorateData(data));
    },
    decorateData: function decorateData(data) {
      var newData = {};

      newData.stages = data.stats || [];
      newData.summary = data.summary || [];

      newData.summary.forEach(function (item) {
        item.value = item.value || '-';
      });

      newData.stages.forEach(function (item) {
        var stageSlug = gl.text.dasherize(item.title.toLowerCase());
        item.active = false;
        item.isUserAllowed = data.permissions[stageSlug];
        item.emptyStageText = EMPTY_STAGE_TEXTS[stageSlug];
        item.component = 'stage-' + stageSlug + '-component';
        item.slug = stageSlug;
      });
      newData.analytics = data;
      return newData;
    },
    setLoadingState: function setLoadingState(state) {
      this.state.isLoading = state;
    },
    setErrorState: function setErrorState(state) {
      this.state.hasError = state;
    },
    deactivateAllStages: function deactivateAllStages() {
      this.state.stages.forEach(function (stage) {
        stage.active = false;
      });
    },
    setActiveStage: function setActiveStage(stage) {
      this.deactivateAllStages();
      stage.active = true;
    },
    setStageEvents: function setStageEvents(events, stage) {
      this.state.events = this.decorateEvents(events, stage);
    },
    decorateEvents: function decorateEvents(events, stage) {
      var newEvents = [];

      events.forEach(function (item) {
        if (!item) return;

        var eventItem = Object.assign({}, DEFAULT_EVENT_OBJECTS[stage.slug], item);

        eventItem.totalTime = eventItem.total_time;

        if (eventItem.author) {
          eventItem.author.webUrl = eventItem.author.web_url;
          eventItem.author.avatarUrl = eventItem.author.avatar_url;
        }

        if (eventItem.created_at) eventItem.createdAt = eventItem.created_at;
        if (eventItem.short_sha) eventItem.shortSha = eventItem.short_sha;
        if (eventItem.commit_url) eventItem.commitUrl = eventItem.commit_url;

        delete eventItem.author.web_url;
        delete eventItem.author.avatar_url;
        delete eventItem.total_time;
        delete eventItem.created_at;
        delete eventItem.short_sha;
        delete eventItem.commit_url;

        newEvents.push(eventItem);
      });

      return newEvents;
    },
    currentActiveStage: function currentActiveStage() {
      return this.state.stages.find(function (stage) {
        return stage.active;
      });
    }
  };
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "g6k9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_limit_warning_component__ = __webpack_require__("KxTB");
/* global Flash */





__webpack_require__("25Yn");
__webpack_require__("3VML");
__webpack_require__("Xl4t");
__webpack_require__("zvts");
__webpack_require__("GtaI");
__webpack_require__("r9QK");
__webpack_require__("8ode");
__webpack_require__("6WU1");
__webpack_require__("vJNZ");
__webpack_require__("ZuDc");
__webpack_require__("sM1W");

$(function () {
  var OVERVIEW_DIALOG_COOKIE = 'cycle_analytics_help_dismissed';
  var cycleAnalyticsEl = document.querySelector('#cycle-analytics');
  var cycleAnalyticsStore = gl.cycleAnalytics.CycleAnalyticsStore;
  var cycleAnalyticsService = new gl.cycleAnalytics.CycleAnalyticsService({
    requestPath: cycleAnalyticsEl.dataset.requestPath
  });

  gl.cycleAnalyticsApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#cycle-analytics',
    name: 'CycleAnalytics',
    data: {
      state: cycleAnalyticsStore.state,
      isLoading: false,
      isLoadingStage: false,
      isEmptyStage: false,
      hasError: false,
      startDate: 30,
      isOverviewDialogDismissed: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(OVERVIEW_DIALOG_COOKIE)
    },
    computed: {
      currentStage: function currentStage() {
        return cycleAnalyticsStore.currentActiveStage();
      }
    },
    components: {
      'stage-issue-component': gl.cycleAnalytics.StageIssueComponent,
      'stage-plan-component': gl.cycleAnalytics.StagePlanComponent,
      'stage-code-component': gl.cycleAnalytics.StageCodeComponent,
      'stage-test-component': gl.cycleAnalytics.StageTestComponent,
      'stage-review-component': gl.cycleAnalytics.StageReviewComponent,
      'stage-staging-component': gl.cycleAnalytics.StageStagingComponent,
      'stage-production-component': gl.cycleAnalytics.StageProductionComponent
    },
    created: function created() {
      this.fetchCycleAnalyticsData();
    },

    methods: {
      handleError: function handleError() {
        cycleAnalyticsStore.setErrorState(true);
        return new Flash('There was an error while fetching cycle analytics data.');
      },
      initDropdown: function initDropdown() {
        var _this = this;

        var $dropdown = $('.js-ca-dropdown');
        var $label = $dropdown.find('.dropdown-label');

        $dropdown.find('li a').off('click').on('click', function (e) {
          e.preventDefault();
          var $target = $(e.currentTarget);
          _this.startDate = $target.data('value');

          $label.text($target.text().trim());
          _this.fetchCycleAnalyticsData({ startDate: _this.startDate });
        });
      },
      fetchCycleAnalyticsData: function fetchCycleAnalyticsData(options) {
        var _this2 = this;

        var fetchOptions = options || { startDate: this.startDate };

        this.isLoading = true;

        cycleAnalyticsService.fetchCycleAnalyticsData(fetchOptions).done(function (response) {
          cycleAnalyticsStore.setCycleAnalyticsData(response);
          _this2.selectDefaultStage();
          _this2.initDropdown();
        }).error(function () {
          _this2.handleError();
        }).always(function () {
          _this2.isLoading = false;
        });
      },
      selectDefaultStage: function selectDefaultStage() {
        var stage = this.state.stages.first();
        this.selectStage(stage);
      },
      selectStage: function selectStage(stage) {
        var _this3 = this;

        if (this.isLoadingStage) return;
        if (this.currentStage === stage) return;

        if (!stage.isUserAllowed) {
          cycleAnalyticsStore.setActiveStage(stage);
          return;
        }

        this.isLoadingStage = true;
        cycleAnalyticsStore.setStageEvents([], stage);
        cycleAnalyticsStore.setActiveStage(stage);

        cycleAnalyticsService.fetchStageData({
          stage: stage,
          startDate: this.startDate
        }).done(function (response) {
          _this3.isEmptyStage = !response.events.length;
          cycleAnalyticsStore.setStageEvents(response.events, stage);
        }).error(function () {
          _this3.isEmptyStage = true;
        }).always(function () {
          _this3.isLoadingStage = false;
        });
      },
      dismissOverviewDialog: function dismissOverviewDialog() {
        this.isOverviewDialogDismissed = true;
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(OVERVIEW_DIALOG_COOKIE, '1');
      }
    }
  });

  // Register global components
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('limit-warning', __WEBPACK_IMPORTED_MODULE_2__components_limit_warning_component__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('total-time', gl.cycleAnalytics.TotalTimeComponent);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "r9QK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_branch_svg__ = __webpack_require__("8Foh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_branch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_icon_branch_svg__);
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StageStagingComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },
    data: function data() {
      return { iconBranch: __WEBPACK_IMPORTED_MODULE_1__svg_icon_branch_svg___default.a };
    },

    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="build in items" class="stage-event-item item-build-component">\n            <div class="item-details">\n              <img class="avatar" :src="build.author.avatarUrl">\n              <h5 class="item-title">\n                <a :href="build.url" class="pipeline-id">#{{ build.id }}</a>\n                <i class="fa fa-code-fork"></i>\n                <a :href="build.branch.url" class="branch-name monospace">{{ build.branch.name }}</a>\n                <span class="icon-branch">' + __WEBPACK_IMPORTED_MODULE_1__svg_icon_branch_svg___default.a + '</span>\n                <a :href="build.commitUrl" class="short-sha monospace">{{ build.shortSha }}</a>\n              </h5>\n              <span>\n                <a :href="build.url" class="build-date">{{ build.date }}</a>\n                by\n                <a :href="build.author.webUrl" class="issue-author-link">\n                  {{ build.author.name }}\n                </a>\n              </span>\n            </div>\n            <div class="item-time">\n              <total-time :time="build.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "sM1W":
/***/ (function(module, exports) {

module.exports = {
  issue: {
    created_at: '',
    url: '',
    iid: '',
    title: '',
    total_time: {},
    author: {
      avatar_url: '',
      id: '',
      name: '',
      web_url: ''
    }
  },
  plan: {
    title: '',
    commit_url: '',
    short_sha: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  code: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  test: {
    name: '',
    id: '',
    date: '',
    url: '',
    short_sha: '',
    commit_url: '',
    total_time: {},
    branch: {
      name: '',
      url: ''
    }
  },
  review: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    state: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  staging: {
    id: '',
    short_sha: '',
    date: '',
    url: '',
    commit_url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    },
    branch: {
      name: '',
      url: ''
    }
  },
  production: {
    title: '',
    created_at: '',
    url: '',
    iid: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  }
};

/***/ }),

/***/ "vJNZ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign */
(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  var CycleAnalyticsService = function () {
    function CycleAnalyticsService(options) {
      _classCallCheck(this, CycleAnalyticsService);

      this.requestPath = options.requestPath;
    }

    _createClass(CycleAnalyticsService, [{
      key: 'fetchCycleAnalyticsData',
      value: function fetchCycleAnalyticsData(options) {
        options = options || { startDate: 30 };

        return $.ajax({
          url: this.requestPath,
          method: 'GET',
          dataType: 'json',
          contentType: 'application/json',
          data: {
            cycle_analytics: {
              start_date: options.startDate
            }
          }
        });
      }
    }, {
      key: 'fetchStageData',
      value: function fetchStageData(options) {
        var stage = options.stage,
            startDate = options.startDate;


        return $.get(this.requestPath + '/events/' + stage.title.toLowerCase() + '.json', {
          cycle_analytics: {
            start_date: startDate
          }
        });
      }
    }]);

    return CycleAnalyticsService;
  }();

  global.cycleAnalytics.CycleAnalyticsService = CycleAnalyticsService;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "zvts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* eslint-disable no-param-reassign */



(function (global) {
  global.cycleAnalytics = global.cycleAnalytics || {};

  global.cycleAnalytics.StageProductionComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
    props: {
      items: Array,
      stage: Object
    },
    template: '\n      <div>\n        <div class="events-description">\n          {{ stage.description }}\n          <limit-warning :count="items.length" />\n        </div>\n        <ul class="stage-event-list">\n          <li v-for="issue in items" class="stage-event-item">\n            <div class="item-details">\n              <img class="avatar" :src="issue.author.avatarUrl">\n              <h5 class="item-title issue-title">\n                <a class="issue-title" :href="issue.url">\n                  {{ issue.title }}\n                </a>\n              </h5>\n              <a :href="issue.url" class="issue-link">#{{ issue.iid }}</a>\n              &middot;\n              <span>\n                Opened\n                <a :href="issue.url" class="issue-date">{{ issue.createdAt }}</a>\n              </span>\n              <span>\n              by\n              <a :href="issue.author.webUrl" class="issue-author-link">\n                {{ issue.author.name }}\n              </a>\n              </span>\n            </div>\n            <div class="item-time">\n              <total-time :time="issue.totalTime"></total-time>\n            </div>\n          </li>\n        </ul>\n      </div>\n    '
  });
})(window.gl || (window.gl = {}));

/***/ })

},["g6k9"]);


// WEBPACK FOOTER //
// cycle_analytics.dedf6450a0d93dc4abae.bundle.js